<script>
export default {
  props: {
    inputValue: Number,
    inputTitle: String,
    fieldName: String,
    inputNotation: String,
    method: { type: Function }
  }
}
</script>

<template>
  <div class="input-row">
    <div class="row-title">{{inputTitle}}</div>
    <div class="input-wrapper">
      <input
          type="number"
          class="compare-input"
          :value="inputValue"
          @input="$emit('updateFormData', fieldName, $event.target.value)"
      />
    <div class="input-notation">{{inputNotation}}</div>
    </div>
  </div>
</template>

<!--<style scoped>-->
<style>
.input-row {
  /*width: 80%;*/
  margin: 0 auto 10px;
}

.input-wrapper {
  background-color: white;
  border-radius: 5px;
  border: 2px solid #43434d;
  margin: 5px 0 0;
  display: flex;
  justify-content: space-between;
}

.row-title {
  font-size: 12px;
}

.compare-input {
  border: 0;
  padding: 5px 5px 5px 10px;
  border-radius: 5px 0 0 5px;
  width: 340px;
}

.input-notation {
  background-color: #f5f5f5;
  width: 40px;
  text-align: center;
  padding: 5px 0;
  word-break: break-word;
  font-size: 14px;
  line-height: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 5px 5px 0;
}
</style>
